<script lang="ts">
  import { readerFontFamily } from '$lib/reader-fonts'
  import { readerOpts } from '$lib/store'

  interface Props {
    text?: string
  }
  let { text: raw }: Props = $props()

  const decode = function (html: any) {
    const txt = document.createElement('textarea')
    txt.innerHTML = html
    return txt.value
  }

  let isBold = false
  if (raw.startsWith('__')) {
    isBold = true
    raw = raw.replace(/^__/, '').replace(/__$/, '')
  }
</script>

{#key $readerOpts}
{#if isBold}
  <strong style="font-family: {readerFontFamily($readerOpts.bodyFont)};">
    {decode(raw).replace('%center%', '')}
  </strong>
{:else}
  <span style="font-family: {readerFontFamily($readerOpts.bodyFont)};">{decode(raw).replace('%center%', '')}</span>
{/if}
{/key}
